<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <!--<v-container grid-list-md text-xs-center class="fluid">-->
    <v-container grid-list-sm fluid class="mt-3" style="background:#FAFAFA">
        <v-container class="border-radius mt-5" style="padding-right:25px!important;padding-left:25px!important">
            <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
            <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
            <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
            <!-- ========================================================================================= -->
            <div>
                <div>
                    <div data-v-221edead="" class="w-100 Results" pricing="true" style=" --custom-color-primary-light:#5CC7000d;">
                        <div data-v-221edead="" class="d-flex flex-column flex-lg-column-reverse">
                            <div data-v-221edead="" class="container">
                                <div class="form">
                                    <div class="page">
                                    <div class="wizard-tab-content">
                                    <div role="tabpanel" id="Popup_autre" aria-hidden="true" aria-labelledby="step-Popup_autre"
                                        class="wizard-tab-container">
                                        <div>
                                        <div class="loan-group loan-group-0">
                                            <div class="fields" v-if="isDesktop()" style="margin-top: 10%">
                                                <div class="field-title font-weight-bold">Durée&nbsp;:</div>
                                                <div class="row" v-if="$store.state.devis.result.branche.branche == 'Automobile'">
                                                    <div class="col-sm-4">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                        <label for="Stepper38" class="field-label">{{ $t('devis.devis_auto.duree_garantie') }}
                                                            <button type="button" tabindex="-1" title="" class="field-help"
                                                            data-original-title="Taux d'intérêt"></button></label>
                                                        <div class="input-group rate-loan">
                                                            <select v-model="duree" id="Stepper24" name="Step8"
                                                            class="field-select">
                                                            <option v-for="item in DureeMois" :key="item" :value="item">{{ item }}</option>
                                                            </select>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-6 ml-3">
                                                        <div class="wizard-card-footer clearfix" style="margin-top: 6%;">
                                                        <div class="wizard-footer-right">
                                                            <button type="button" @click="getPrimeSimulate()" class="wizard-btn">
                                                            Simuler
                                                            </button>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row" v-if="$store.state.devis.result.branche.branche == 'Voyage'">
                                                    <div class="col-sm-4">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                        <label for="Stepper38" class="field-label">{{$t('devis.devis_voyage.paysVoyage.Headline_2')}}</label>
                                                        <div class="input-group rate-loan">
                                                            <select v-model="destination" id="Stepper24" name="Step8"
                                                            class="field-select">
                                                            <option v-for="item in countries" :key="item" :value="item.PAYS">{{item.PAYS}}</option>
                                                            </select>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-4">
                                                        <div class="field-group field-default ">
                                                        <label for="Stepper25" class="field-label">
                                                            {{$t('devis.devis_voyage.dateVoyage.Headline_1')}} 
                                                            <!---->
                                                        </label>
                                                        <div class="input-group value-loan">
                                                            <date-picker :disabled-date="disabledAfterToday" class="field-input ml-2 mb-1" placeholder="Cliquer ici" id="Stepper25" @change="yearsDiffDateDepart()" v-model="dateDepart" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-4">
                                                        <div class="field-group field-default">
                                                        <label for="Stepper25_2" class="field-label">
                                                            {{$t('devis.devis_voyage.dateVoyage.Headline_2')}}
                                                            <!---->
                                                        </label>
                                                        <div class="input-group value-loan">
                                                            <date-picker :disabled-date="disabledAfterToday" class="field-input ml-2 mb-1 " placeholder="Cliquer ici" id="Stepper25_2" @change="yearsDiffDateRetour()" v-model="dateArrivee" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div class="wizard-card-footer clearfix" style="margin-top: 6%;">
                                                        <div class="wizard-footer-right">
                                                            <button type="button" @click="getPrimeSimulate()" class="wizard-btn">
                                                            Simuler
                                                            </button>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="fields" style="margin-top: 50%;" v-if="isMobile()">
                                            <div  v-if="$store.state.devis.result.branche.branche == 'Automobile'" class="field-title font-weight-bold">Durée&nbsp;:
                                            </div>
                                            <div class="row" v-if="$store.state.devis.result.branche.branche == 'Automobile'">
                                                
                                                <div class="col-sm-12">
                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                    <label for="Stepper38" class="field-label">{{ $t('devis.devis_auto.duree_garantie') }}
                                                        <button type="button" tabindex="-1" title="" class="field-help"
                                                        data-original-title="Taux d'intérêt"></button></label>
                                                    <div class="input-group rate-loan">
                                                        <select v-model="duree" id="Stepper24" name="Step8"
                                                        class="field-select">
                                                        <option v-for="item in DureeMois" :key="item" :value="item">{{ item }}</option>
                                                        </select>
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row" v-if="$store.state.devis.result.branche.branche == 'Voyage'">
                                                <div class="col-sm-24">
                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                    <label for="Stepper38" class="field-label">{{$t('devis.devis_voyage.paysVoyage.Headline_2')}}</label>
                                                    <div class="input-group rate-loan">
                                                        <select v-model="destination" id="Stepper24" name="Step8"
                                                        class="field-select">
                                                        <option v-for="item in countries" :key="item" :value="item.PAYS">{{item.PAYS}}</option>
                                                        </select>
                                                    </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-24">
                                                    <div class="field-group field-default">
                                                    <label for="Stepper25" class="field-label">
                                                        {{$t('devis.devis_voyage.dateVoyage.Headline_1')}} 
                                                        <!---->
                                                    </label>
                                                    <div class="input-group value-loan">
                                                        <date-picker :disabled-date="disabledAfterToday" class="field-input ml-2 mb-1" placeholder="Cliquer ici" id="Stepper25" @change="yearsDiffDateDepart()" v-model="dateDepart" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                    </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-24">
                                                    <div class="field-group field-default">
                                                    <label for="Stepper25_2" class="field-label">
                                                        {{$t('devis.devis_voyage.dateVoyage.Headline_2')}}
                                                        <!---->
                                                    </label>
                                                    <div class="input-group value-loan">
                                                        <date-picker :disabled-date="disabledAfterToday" class="field-input ml-2 mb-1 " placeholder="Cliquer ici" id="Stepper25_2" @change="yearsDiffDateRetour()" v-model="dateArrivee" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                    </div>
                                                    </div>
                                                </div>
                                                </div>
                                            
                                                    <div class="wizard-card-footer clearfix">
                                                    <div class="wizard-footer-right">
                                                        <button type="button" @click="getPrimeSimulate()" class="wizard-btn">
                                                        Simuler
                                                        </button>
                                                    </div>
                                                    </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                                </div>
                                
                            </div>
                        </div>

                        <div data-v-221edead="" class="container mt-5">
                            <p data-v-221edead="">{{ $t('list_devis.list_devis_title[0]') }} <strong data-v-221edead="">{{ $t('list_devis.list_devis_title[1]') }}</strong> {{ $t('list_devis.list_devis_title[2]') }} {{listdevis.length}} {{ $t('list_devis.list_devis_title[3]') }}</p>
                            <p v-if="brancheTocheck  != 'Voyage'" data-v-221edead="" class="mr-3 mt-3">Prime TTC sur <span class="font-weight-bold" style="color: #ffa409;">{{ $store.state.devis.duree }} mois :</span></p>

                            <div class="row" v-if="isDesktop()">
                                <div class="col-lg-4" v-for="(assur,index) in listdevis" :key="index">
                                <div class="pricing-box rounded text-center p-4">
                                    <div>
                                        <img :src="assur.image" width="80" height="80" alt="logo partenaire" style="border-radius: 10px;">
                                    </div>
                                    <h4 class="title mb-3">{{ assur.societe }}</h4>
                                    <h1 class="font-weight-bold mb-0 mt-3">
                                    <b>
                                        {{ assur.tarif.toLocaleString() }} FCFA
                                    </b>
                                    </h1>
                                    <a href="javascript: void(0);" class="btn btn-outline-primary pr-btn mt-4" @click="btn2_clicked(assur)">{{ $t('list_devis.souscrire_label') }}</a>
                                    <div class="mt-3">
                                    </div>
                                </div>
                                </div>
                            </div>

                            <div class="row" v-if="isMobile()">
                                <div class="col-lg-12" v-for="(assur,index) in listdevis" :key="index">
                                <div class="pricing-box rounded text-center p-4">
                                    <div>
                                        <img :src="assur.image" width="80" height="80" alt="logo partenaire" style="border-radius: 10px;">
                                    </div>
                                    <h4 class="title mb-3">{{ assur.societe }}</h4>
                                    <h1 class="font-weight-bold mb-0 mt-3">
                                    <b>
                                        {{ assur.tarif.toLocaleString() }} FCFA
                                    </b>
                                    </h1>
                                    <a href="javascript: void(0);" class="btn btn-outline-primary pr-btn mt-4" @click="btn2_clicked(assur)">{{ $t('list_devis.souscrire_label') }}</a>
                                    <div class="mt-3">
                                    </div>
                                </div>
                                </div>
                            </div>
                                                             
                        </div>
                    </div>
                </div>
                <!-- popup pour demande d'assistance -->
                <!-- popup pour demande d'assistance -->
                <v-dialog v-model="assistanceDialog" max-width="800">
                  <v-card elevation="24" class="border-radius">
                    <v-card-text style="background:#FAFAFA">
                      <div class="wizard-tab-content">
                          <div role="tabpanel" id="infosAssistance" aria-hidden="true" aria-labelledby="step-infosAssistance" class="wizard-tab-container">
                              <div>
                                  <div class="loan-group loan-group-0">
                                      <div class="fields">
                                          <div class="field-title font-weight-bold">{{ $t('list_devis.assistance_form.assistance_title') }}</div>
                                          <div class="row">
                                              <div class="col-sm-4">
                                                  <div class="field-group field-default mb-4 mb-sm-0">
                                                      <label for="HoraireRappel" class="field-label">{{ $t('list_devis.assistance_form.horaire_rappel_label') }}</label>
                                                      <select id="HoraireRappel" name="infosAssis" class="field-select" v-model="horaire">
                                                          <option v-for="itm in itema" :key="itm" :value="itm">{{itm}}</option>
                                                      </select>
                                                  </div>
                                              </div>
                                              <div class="col-sm-4">
                                                  <div class="field-group field-default mb-4 mb-sm-0">
                                                      <label for="CanalRappel" class="field-label">{{ $t('list_devis.assistance_form.canal_rappel_label') }}</label>
                                                      <select id="CanalRappel" name="infosAssis" class="field-select" v-model="canal">
                                                          <option v-for="itm in rappel" :key="itm" :value="itm">{{itm}}</option>
                                                      </select>
                                                  </div>
                                              </div>
                                              <div class="col-sm-4">
                                                  <div class="field-group field-default mb-4 mb-sm-0">
                                                      <label for="nom" class="field-label">{{ $t('list_devis.assistance_form.nom_label') }}</label>
                                                      <input v-model="name" :placeholder="$t('list_devis.assistance_form.nom_placeholder')" id="nom" name="infosAssis" class="field-input">
                                                  </div>
                                              </div>
                                          </div>

                                          <div class="row">
                                              <div class="col-sm-4">
                                                  <div class="field-group field-default">
                                                      <label for="num" class="field-label">
                                                        {{ $t('list_devis.assistance_form.telephone_label') }}
                                                      </label>
                                                      <div class="input-group value-loan">
                                                          <input :placeholder="$t('list_devis.assistance_form.telephone_placeholder')" v-model="tel" id="num" name="infosAssis" class="field-input">
                                                      </div>
                                                  </div>
                                              </div>
                                              <div class="col-sm-4">
                                                  <div class="field-group field-default">
                                                      <label for="Object" class="field-label">
                                                        {{ $t('list_devis.assistance_form.objet_label') }}
                                                      </label>
                                                      <div class="input-group value-loan">
                                                          <input :placeholder="$t('list_devis.assistance_form.objet_placeholder')" v-model="objetRappel" id="Object" name="infosAssis" disabled class="field-input">
                                                      </div>
                                                  </div>
                                              </div>
                                              <div class="col-sm-4">
                                                  <div class="field-group field-default">
                                                      <label for="Remarque" class="field-label">
                                                        {{ $t('list_devis.assistance_form.remarque_label') }}
                                                      </label>
                                                      <div class="input-group value-loan">
                                                          <textarea rows="4" cols="50" :placeholder="$t('list_devis.assistance_form.remarque_placeholder')" v-model="remarques" id="Remarque" name="infosAssis" class="field-input"></textarea>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="wizard-card-footer clearfix">
                          <div class="wizard-footer-left">
                              <button @click="assistanceDialog = false" type="button" class="wizard-btn">
                                  <span class="fas fa-arrow-left"></span>
                                  {{ $t('list_devis.assistance_form.bouton_fermer_label') }}
                              </button>
                          </div>
                          <div class="wizard-footer-right">
                              <button @click="AddAssistance()" type="button" class="wizard-btn">
                                {{ $t('list_devis.assistance_form.bouton_valider_label') }}
                              </button>
                          </div>
                      </div>
                  </v-card-text>
                  </v-card>
                </v-dialog>

                <!-- popup pour nouveau vehicule ou mes vehicules -->
                <!-- popup pour nouveau vehicule ou mes vehicules -->
                <v-dialog v-model="getSimuleCarModal" max-width="1000">
                  <v-card elevation="24" class="border-radius">
                    <v-card-text style="background:#FAFAFA">
                      <div class="wizard-tab-content">
                          <div role="tabpanel" id="infosAssistance" aria-hidden="true" aria-labelledby="step-infosAssistance" class="wizard-tab-container">
                              <div>
                                  <div class="loan-group loan-group-0">
                                    <div class="fields" v-if="isDesktop()">
                                        <div class="field-title">{{ $t('devis.devis_auto.stepper_one_subtitle_one') }}</div>
                                        <div class="field-group justify-content-center row flex-column flex-sm-row">
                                            <div class="btn-choice btn-choice-icon sm-no-change">
                                            <input v-model="myCars" value="mes_vehicule" type="radio"
                                                id="Stepper1_1_2" name="Step1"
                                                class="field-input" @change="getListVehicule">
                                            <label for="Stepper1_1_2" class="flex-row flex-md-column field-label">
                                                <img src="../../assets/img/icones/the_cars.png" alt="mes véhicules" class="mr-4 mr-md-0">
                                                <p>{{ $t('devis.devis_auto.my_vehicule') }}</p>
                                            </label>
                                            </div>
                                            <div class="ml-4 btn-choice btn-choice-icon sm-no-change">
                                            <input v-model="myCars" type="radio" value="nouveau" id="Stepper2_2_3"
                                                name="Step1" class="field-input" @change="getListVehicule">
                                            <label for="Stepper2_2_3" class="flex-row flex-md-column field-label">
                                                <img src="../../assets/img/icones/mycars.png" alt="nouveau véhicule" class="mr-4 mr-md-0">
                                                <p>{{ $t('devis.devis_auto.new_vehicule') }}</p>
                                            </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="fields" v-else>
                                        <div class="field-title">{{ $t('devis.devis_auto.stepper_one_subtitle_one') }}</div>
                                        <div class="field-group justify-content-center row flex-column flex-sm-row">
                                            <div class="btn-choice btn-choice-icon sm-no-change">
                                            <input v-model="myCars" value="mes_vehicule" type="radio"
                                                id="Stepper1_1_2" name="Step1"
                                                class="field-input" @change="getListVehicule">
                                            <label for="Stepper1_1_2" class="flex-row flex-md-column field-label">
                                                <img src="../../assets/img/icones/the_cars.png" alt="mes véhicules" class="mr-4 mr-md-0">
                                                <p>{{ $t('devis.devis_auto.my_vehicule') }}</p>
                                            </label>
                                            </div>
                                            <div class="btn-choice btn-choice-icon sm-no-change" style="margin-top: 15px;">
                                            <input v-model="myCars" type="radio" value="nouveau" id="Stepper2_2_3"
                                                name="Step1" class="field-input" @change="getListVehicule">
                                            <label for="Stepper2_2_3" class="flex-row flex-md-column field-label">
                                                <img src="../../assets/img/icones/mycars.png" alt="nouveau véhicule" class="mr-4 mr-md-0">
                                                <p>{{ $t('devis.devis_auto.new_vehicule') }}</p>
                                            </label>
                                            </div>
                                        </div>
                                    </div>


                                    <!-- Cette section doit être corrigée pour bien afficher les images -->
                                    <div class="fields" v-if="infosSupOfVehicle && myCars == 'nouveau'" style="z-index: 10000;">
                                        <div class="field-title font-weight-bold">{{
                                            $t('devis.devis_auto.marque_model_title') }}&nbsp;:</div>
                                        <div class="justify-content-center row" v-if="getSimuleData.vehicul[0].categorie == 'categorie 1'">
                                            <div class="col-sm-4">
                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                <label for="Stepper20" class="field-label">{{ $t('devis.devis_auto.marque') }}</label>
                                                <v-overflow-btn flat v-model="marque" :items="listeMarque" editable id="Stepper20"
                                                item-text="Marque" item-value="Marque" @change="onChangeSelectedMarque"
                                                style="margin-top: 5px;width: 100%;height: 65px;padding: 8px;line-height: 1;font-size: 1.6rem;background-color: #fff;border: 1px solid #d9dee3;border-radius: 12px;"></v-overflow-btn>
                                            </div>
                                            </div>
                                            <div class="col-sm-4" v-show="marque" v-if="marque">
                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                <label for="Stepper21" class="field-label">{{ $t('devis.devis_auto.model') }}</label>
                                                <v-overflow-btn flat v-model="model" :items="listeModeles" editable item-text="Type"
                                                id="Stepper21" item-value="Type" @change="onChangeSelectedModele"
                                                style="margin-top: 5px;width: 100%;height: 65px;padding: 8px;line-height: 1;font-size: 1.6rem;background-color: #fff;border: 1px solid #d9dee3;border-radius: 12px;"></v-overflow-btn>
                                            </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="field-group field-default mb-4 mb-sm-0">
                                                <label for="Stepper28" class="field-label">{{ $t('devis.devis_auto.immatriculation')
                                                }}</label>
                                                <input maxlength="10" @input="validateImmatriculation" v-model="immatriculation" placeholder="Votre plaque" id="Stepper28" name="Step8" class="field-input" style="height: 65px;">
                                                </div>
                                            </div>
                                        </div>


                                        <div class="justify-content-center row" v-if="getSimuleData.vehicul[0].categorie == 'categorie 5'">
                                            <div class="col-sm-6">
                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                <label for="Stepper22" class="field-label">{{ $t('devis.devis_auto.marque') }}</label>
                                                <v-overflow-btn flat v-model="marque" :items="listeMarque2roues" editable
                                                item-text="Marque" id="Stepper22" item-value="Marque"
                                                @change="onChangeSelectedMarque2roues"
                                                style="width: 100%;height: 65px;padding: 8px;line-height: 1;font-size: 1.6rem;background-color: #fff;border: 1px solid #d9dee3;border-radius: 12px;"></v-overflow-btn>
                                            </div>
                                            </div>
                                            <div class="col-sm-6" v-show="marque" v-if="marque">
                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                <label for="Stepper23" class="field-label">{{ $t('devis.devis_auto.model') }}</label>
                                                <v-overflow-btn flat v-model="model" :items="listeModeles2roues" editable item-text="Type"
                                                id="Stepper23" item-value="Type" @change="onChangeSelectedModele2roues"
                                                style="width: 100%;height: 65px;padding: 8px;line-height: 1;font-size: 1.6rem;background-color: #fff;border: 1px solid #d9dee3;border-radius: 12px;"></v-overflow-btn>
                                            </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="fields" v-if="infosSupOfVehicle">
                                        <div class="field-title font-weight-bold">{{ $t('devis.devis_auto.periode_garantie_title')
                                        }}&nbsp;:</div>
                                        <div class="row">
                                        <!-- <div class="col-sm-4">
                                            <div class="field-group field-default mb-4 mb-sm-0">
                                            <label for="Stepper38" class="field-label">{{ $t('devis.devis_auto.duree_garantie') }}
                                                <button type="button" tabindex="-1" title="" class="field-help"
                                                data-original-title="Taux d'intérêt"></button></label>
                                            <div class="input-group rate-loan">
                                                <select @change="dateDiff()" v-model="duree" id="Stepper24" name="Step8"
                                                class="field-select">
                                                <option v-for="item in DureeMois" :key="item" :value="item">{{ item }}</option>
                                                </select>
                                            </div>
                                            </div>
                                        </div> -->
            
                                        <div class="col-sm-6">
                                            <div class="field-group field-default mb-4 mb-sm-0">
                                            <label for="Stepper39" class="field-label">{{ $t('devis.devis_auto.date_effet') }}
                                                <button type="button" tabindex="-1" title="" class="field-help"
                                                data-original-title="Taux d'intérêt"></button></label>
                                            <div class="input-group rate-loan">
                                                <date-picker id="Stepper39" :disabled-date="disabledAfterToday"
                                                class="field-input ml-2 mb-1 mt-1"
                                                :placeholder="$t('devis.devis_auto.date_effet_placeholder')" @change="dateDiff()"
                                                :min="new Date().toISOString().substr(0, 10)" v-model="dateEffet" valueType="format"
                                                format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                            </div>
                                            </div>
                                        </div>
            
                                        <div class="col-sm-6">
                                            <div class="field-group field-default mb-4 mb-sm-0">
                                            <label for="Stepper40" class="field-label">{{ $t('devis.devis_auto.date_echeance') }}
                                                <button type="button" tabindex="-1" title="" class="field-help"
                                                data-original-title="Taux d'intérêt"></button></label>
                                            <div class="input-group rate-loan">
                                                <input disabled :placeholder="$t('devis.devis_auto.date_echeance_placeholder')"
                                                v-model="dateEcheance" id="Stepper40" name="Step11" class="field-input">
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="wizard-card-footer clearfix" v-if="infosSupOfVehicle">
                          <div class="wizard-footer-left">
                              <button @click="getSimuleCarModal = false" type="button" class="wizard-btn">
                                  <span class="fas fa-arrow-left"></span>
                                  {{ $t('list_devis.assistance_form.bouton_fermer_label') }}
                              </button>
                          </div>
                          <div class="wizard-footer-right">
                              <button @click="createDevis()" type="button" class="wizard-btn">
                                {{ $t('list_devis.assistance_form.bouton_valider_label') }}
                              </button>
                          </div>
                      </div>
                  </v-card-text>
                  </v-card>
                </v-dialog>

                <!--    ==========================Modal for cars desktop ============================================ -->
                <v-dialog persistent v-model="ModalListeContrat" max-width="700" v-if="isDesktop()">
                <v-card tile class="border-radius policeLato">
                    <v-card-text style="background:#FAFAFA">
                    <div class="wizard-tab-content">
                        <div role="tabpanel" id="UserCarTable" aria-hidden="true" aria-labelledby="step-UserCarTable"
                        class="wizard-tab-container">
                        <div>
                            <div class="loan-group loan-group-0">
                            <div class="fields">
                                <div class="field-title font-weight-bold">{{ $t('devis.devis_auto.my_vehicule') }}&nbsp;:</div>
                                <div class="row">
                                <div class="col-sm-12">
                                    <v-flex class="col-sm-5 offset-7">
                                    <div class="col-sm-12">
                                        <div class="field-group field-default mb-4 mb-sm-0">
                                        <input v-model="searchCarDesktop" :placeholder="$t('devis.devis_auto.chercher')"
                                            id="Stepper288" name="Step8" class="field-input">
                                        </div>
                                    </div>
                                    </v-flex>

                                    <v-flex style="background-color: #FAFAFA!important;z-index:10000">
                                    <v-data-table :headers="$t('devis.devis_auto.headerContratSimulate')" :items="listCars"
                                        :search="searchCarDesktop" class="border-radius mt-2 mb-5"
                                        style="background-color: #FAFAFA!important">
                                        <template slot="items" slot-scope="props">
                                        <td>{{ props.item.marque }}</td>
                                        <td>{{ props.item.model }}</td>
                                        <td>{{ props.item.nbplace }}</td>
                                        <td>{{ props.item.immatriculation }}</td>
                                        <td>{{ props.item.valeur_venale }}</td>
                                        <td>
                                            <ul class="list-boutons">
                                            <li>
                                                <v-btn small icon @click="getCarForDevis(props.item)">
                                                <img src="../../assets/img/devis/toDevis.png" width="60" alt="pour un devis">
                                                </v-btn>
                                            </li>
                                            </ul>
                                        </td>
                                        </template>
                                    </v-data-table>
                                    </v-flex>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div class="wizard-card-footer clearfix">
                        <div class="wizard-footer-left">
                        <button @click="ModalListeContrat = false" type="button" class="wizard-btn">
                            <span class="fas fa-arrow-left"></span>
                            {{ $t('devis.devis_auto.bouton_retour') }}
                        </button>
                        </div>
                        <div class="wizard-footer-right">
                        </div>
                        <!---->
                    </div>
                    </v-card-text>
                </v-card>
                </v-dialog>

                 <!--    ==========================Modal for cars mobile ============================================ -->
                <v-dialog persistent v-model="ModalListeContrat" v-if="isMobile()" style="width:100%!important">
                    <v-card tile class="border-radius policeLato">
                    <v-card-text style="background:#FAFAFA">
                        <div class="wizard-tab-content">
                        <div role="tabpanel" id="UserCarTable" aria-hidden="true" aria-labelledby="step-UserCarTable"
                            class="wizard-tab-container">
                            <div>
                            <div class="loan-group loan-group-0">
                                <div class="fields">
                                <div class="field-title font-weight-bold">{{ $t('devis.devis_auto.my_vehicule') }}&nbsp;:</div>
                                <div class="row">
                                    <div class="col-sm-12">
                                    <div class="col-sm-12">
                                        <div class="field-group field-default mb-4 mb-sm-0">
                                        <input v-model="searchCarDesktop" :placeholder="$t('devis.devis_auto.chercher')"
                                            id="Stepper288" name="Step8" class="field-input">
                                        </div>
                                    </div>
            
                                    <v-flex style="background-color: #FAFAFA!important;z-index:10000">
                                        <v-data-table :headers="$t('devis.devis_auto.headerContratMobile')" :items="listCars"
                                        :search="searchCarDesktop" class="border-radius mt-2 mb-5"
                                        style="background-color: #FAFAFA!important">
                                        <template slot="items" slot-scope="props">
                                            <td @click="getCarForDevis(props.item)">{{ props.item.marque }}</td>
                                            <td @click="getCarForDevis(props.item)">{{ props.item.model }}</td>
                                            <td @click="getCarForDevis(props.item)">{{ props.item.immatriculation }}</td>
                                        </template>
                                        </v-data-table>
                                    </v-flex>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                        <div class="wizard-card-footer clearfix">
                        <div class="wizard-footer-left">
                            <button @click="ModalListeContrat = false" type="button" class="wizard-btn">
                            <span class="fas fa-arrow-left"></span>
                            {{ $t('devis.devis_auto.bouton_retour') }}
                            </button>
                        </div>
                        <div class="wizard-footer-right">
                        </div>
                        <!---->
                        </div>
                    </v-card-text>
                    </v-card>
                </v-dialog>

                <!-- ========= DIALOG SI LA VOITURE N'EXISTE PAS DANS LA LISTE ============ -->

                <!-- ========= DIALOG SI LA VOITURE N'EXISTE PAS DANS LA LISTE ============ -->
                <v-dialog v-model="popupAutre" width="500" persistent>
                    <!-- ========= DIALOG SI LA VOITURE N'EXISTE PAS DANS LA LISTE ============ -->
                    <v-card elevation="24" class="border-radius">
                    <v-card-text style="background:#FAFAFA">
                        <div class="wizard-tab-content">
                        <div role="tabpanel" id="Popup_autre" aria-hidden="true" aria-labelledby="step-Popup_autre"
                            class="wizard-tab-container">
                            <div>
                            <div class="loan-group loan-group-0">
                                <div class="fields">
                                <div class="field-title font-weight-bold">{{ $t('devis.devis_auto.saisir_marque_title') }}&nbsp;:
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                    <div class="field-group field-default">
                                        <label for="autreMarque" class="field-label">
                                        {{ $t('devis.devis_auto.marque') }}
                                        </label>
                                        <div class="input-group value-loan">
                                        <input placeholder="Marque de votre véhicule" v-model="marque" id="autreMarque"
                                            name="Popup_autre" class="field-input">
                                        </div>
                                    </div>
                                    </div>
                                    <div class="col-sm-6">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                        <label for="autreModel" class="field-label">{{ $t('devis.devis_auto.model') }}</label>
                                        <input v-model="model" placeholder="Modèle de votre véhicule" id="autreModel" name="Popup_autre"
                                        class="field-input">
                                    </div>
                                    </div>
                                </div>
                                </div>
            
                                <div class="wizard-card-footer clearfix">
                                <div class="wizard-footer-left">
                                    <button @click="popupAutre = false" type="button" class="wizard-btn">
                                    <span class="fas fa-arrow-left"></span>
                                    {{ $t('devis.devis_auto.bouton_retour') }}
                                    </button>
                                </div>
                                <div class="wizard-footer-right">
                                    <button @click="validMarqueModel()" type="button" class="wizard-btn">
                                    {{ $t('devis.devis_auto.bouton_valider') }}
                                    </button>
                                </div>
                                <!---->
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </v-card-text>
                    </v-card>
            
                    <!-- ========= DIALOG SI LE 2ROUES N'EXISTE PAS DANS LA LISTE ============ -->
                    <!-- <v-card elevation="24" class="border-radius" v-if="getSimuleData.vehicul[0].categorie == '2_roues'">
                    <v-card-text style="background:#FAFAFA">
                        <div class="wizard-tab-content">
                        <div role="tabpanel" id="Popup_autre_2_roues" aria-hidden="true" aria-labelledby="step-Popup_autre_2_roues"
                            class="wizard-tab-container">
                            <div>
                            <div class="loan-group loan-group-0">
                                <div class="fields">
                                <div class="field-title font-weight-bold">{{ $t('devis.devis_auto.saisir_marque_title') }}&nbsp;:
                                </div>
                                <div class="row">
                                    <div class="col-sm-4">
                                    <div class="field-group field-default">
                                        <label for="autreMarque_2_roues" class="field-label">
                                        {{ $t('devis.devis_auto.marque') }}
                                        </label>
                                        <div class="input-group value-loan">
                                        <input placeholder="Marque de votre véhicule" v-model="marque" id="autreMarque_2_roues"
                                            name="Popup_autre_2_roues" class="field-input">
                                        </div>
                                    </div>
                                    </div>
                                    <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                        <label for="autreModel_2_roues" class="field-label">{{ $t('devis.devis_auto.model') }}</label>
                                        <input v-model="model" placeholder="Modèle de votre véhicule" id="autreModel_2_roues"
                                        name="Popup_autre_2_roues" class="field-input">
                                    </div>
                                    </div>
                                    <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                        <label for="autreCylinde_2_roues" class="field-label">{{ $t('devis.devis_auto.cylindre')
                                        }}</label>
                                        <input type="number" v-model="cylindre" placeholder="Cylindree(cm3) du véhicule"
                                        id="autreCylinde_2_roues" name="Popup_autre_2_roues" class="field-input">
                                    </div>
                                    </div>
                                </div>
                                </div>
            
                                <div class="wizard-card-footer clearfix">
                                <div class="wizard-footer-left">
                                    <button @click="popupAutre = false" type="button" class="wizard-btn">
                                    <span class="fas fa-arrow-left"></span>
                                    {{ $t('devis.devis_auto.bouton_retour') }}
                                    </button>
                                </div>
                                <div class="wizard-footer-right">
                                    <button @click="validMarqueModel()" type="button" class="wizard-btn">
                                    {{ $t('devis.devis_auto.bouton_valider') }}
                                    </button>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </v-card-text>
                    </v-card> -->
                </v-dialog>
            </div>

        </v-container>

        <div v-if="dialogLoading" class="loading-state">
            <div class="loading"></div>
            <span class="ml-3 loading-text">{{ $t('devis.devis_auto.devis_encours')}}</span>
        </div>

        <!-- <v-dialog v-model="dialogLoading" persistent width="700">
            <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FFA409">
                <div class="wizard-tab-content" style="background:#FFA409">
                <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso"
                    class="wizard-tab-container">
                    <div>
                    <div class="loan-group loan-group-0" style="background:#FFA409">
                        <div class="fields text-center" style="background:#FFA409">
                        <v-progress-circular size="50" color="white" class="mr-2" indeterminate></v-progress-circular>
                        <span class="field-title font-weight-bold" style="color:#fff">{{ $t('devis.devis_auto.devis_encours')
                        }}</span>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </v-card-text>
            </v-card>
        </v-dialog> -->

         <div v-if="dialogSimulateLoading" class="loading-state">
            <div class="loading"></div>
            <span class="ml-3 loading-text">Simulation en cours, Veuillez patienter !</span>
        </div>

        <!-- <v-dialog v-model="dialogSimulateLoading" persistent width="700">
            <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FFA409">
                <div class="wizard-tab-content" style="background:#FFA409">
                <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso"
                    class="wizard-tab-container">
                    <div>
                    <div class="loan-group loan-group-0" style="background:#FFA409">
                        <div class="fields text-center" style="background:#FFA409">
                        <v-progress-circular size="50" color="white" class="mr-2" indeterminate></v-progress-circular>
                        <span class="field-title font-weight-bold" style="color:#fff">Simulation en cours, Veuillez patienter !</span>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </v-card-text>
            </v-card>
        </v-dialog> -->

        <login-form :visible="showLoginForm" @close="showLoginForm = false"></login-form>

    </v-container>
</template>

<script>
    import Api from '../../services/Api'
    import store from "../../store/store";
    import dayjs from 'dayjs';
    import {mapGetters} from 'vuex'
    import PushInDataLayer from '../../services/TagManager'
    import _ from 'underscore'
    import MarqueVehicule from '../../common/marqueauto.json'
    import Marque2roues from '../../common/2roues.json'
    import MarqueImage from '../../common/marqueimage.json'
    import LoginForm from '../auth/Login'
    import configVoyage from '../../common/configVoyage.json'

    export default {
        name: "ListOffreSimulate",
        components : {
            LoginForm
        },
        data() {
            return {
                dateDepart: null,
                dateArrivee: null,
                duree_contrat : null,
                destination : null,
                countries: [],
                dialogLoading : false,
                dialogSimulateLoading : false,
                getSimuleData: null,
                getSimuleCarModal : false,
                myCars : null,
                ModalListeContrat : false,
                listCars : [],
                userCars: [],
                carDetails : {},
                marque: null,
                model: null,
                immatriculation: null,
                infosSupOfVehicle : false,
                listeMarque: MarqueVehicule,
                listeMarque2roues: Marque2roues,
                listeModeles: null,
                listeModeles2roues: null,
                selectedMarque: null,
                popupAutre: false,
                MarqueAuto : MarqueImage.auto,
                showLoginForm: false,
                DureeMois: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                dateEffet : null, 
                dateEcheance : null,
                ageArrivee :null,



                ifDevisIsAuto: false,
                ecommerce:[],
                devis_price:null,
                HideDive: null,
                HideButton: true,
                devisVoyage: [],
                listdevis: [],
                DevisFinal: [],
                assureurs: [],
                assistanceDialog: false,
                notif: null,
                GtmAssistanceVal:{},
                brancheTocheck: '',
                Mano: null,
                ToastTabSucess: {
                    theme: "toasted-primary",
                    position: "top-center",
                    duration: 5000,
                    fitToScreen: true,
                    type: 'success',
                    className: 'custom-success-class'
                }, // Customized options for success toast
                ToastTabError: {
                    theme: "toasted-primary",
                    position: "top-center",
                    duration: 5000,
                    fitToScreen: true,
                    type: 'error'
                },// Customized options for error toast
                headers: [
                    {text: 'Assureurs', align: 'left', sortable: false, value: 'societe'},
                ],
                itema: ['Le plus tôt possible', 'Dans la matinée', 'Dans la journée'],
                rappel: ['Whatsapp', 'Appel', 'Email'],
                objet: ['Devis', 'Souscription', 'Contrat', 'Paiement', 'Conseil', 'Sinistre', 'Autres'],
                horaire: null,
                canal: null,
                name: null,
                tel: null,
                objetRappel: null,
                remarques: null,
                timer: '',
                ExitByUser: true
            }
        },
        computed: {
            ...mapGetters([
                'username'
            ])
        },
        created() {
            //this.fetchEventsList();
            //this.timer = setInterval(this.fetchEventsList, 60000)
        },

        methods: {
            yearsDiffDateDepart() {
                const date1 = dayjs(this.dateDepart);
                const date2 = dayjs(new Date().toISOString().substr(0, 10));
                let daydiff = date2.diff(date1, 'days');
                let ageDepart = daydiff;

                if (ageDepart > 0) {
                    ageDepart = null;
                    this.$toasted.show('Erreur, date postérieure à la date actuelle! ', this.ToastTabError)
                    this.dateDepart = null

                } else if (ageDepart <= 29) {
                    this.an = this.annee_mois = 'jour(s)'

                } else if (ageDepart >= 30, ageDepart <= 360) {
                    year = Math.floor(ageDepart / 30);
                    ageDepart = year;

                } else if (this.ageDepart >= 360) {
                    let year = Math.floor(this.age / 360);
                    ageDepart = year;
                    year = ageDepart;
                }

            },
            yearsDiffDateRetour() {
                const date1 = dayjs(this.dateArrivee);
                const date2 = dayjs(this.dateDepart);
                let daydiff = date2.diff(date1, 'days');

                let ageArrivee = daydiff;

                if (ageArrivee > 0) {
                    ageArrivee = null;
                    this.$toasted.show('Erreur, date postérieure à la date de départ! ', this.ToastTabError)
                    this.dateArrivee = null

                }else {
                    this.daysDiff()
                }

            },

            daysDiff() {
                const date1 = dayjs(this.dateDepart);
                const date2 = dayjs(this.dateArrivee);
                let daydiff = date2.diff(date1, 'day');
                this.duree_contrat = daydiff + 1;
                //this.dateDiff()
            },

            disabledBeforeToday(date) {
              const today = dayjs(this.dateDepart).add(+1, 'day')
              return date < today;
            },
            disabledAfterToday(date) {
              const today = dayjs(new Date()).add(-1, 'day')
              return date < today;
            },
             /*====Recuperation de la liste des Pays depuis API====*/
            getListePays: function () {
                Api().get('pays')
                    .then(response => {
                        this.countries = response.data

                    })
                    .catch(err => {
                        err
                    })
            },
            // yearsDiffDateEffet() {
            //     const date1 = dayjs(this.getSimuleData.dateEffet);
            //     const date2 = dayjs(new Date().toISOString().substr(0, 10));
            //     let daydiff = date2.diff(date1, 'days');
        
            //     this.ageArrivee = daydiff;
        
            //     if (this.ageArrivee > 0) {
            //     this.ageArrivee = null;
            //     // this.annee_mois = '';
            //     this.$toasted.show('Erreur, date postérieure à la date actuelle! ', this.ToastTabError)
            //     this.dateEffet = null
        
            //     }
        
            // },
            dateDiff: function () {
                if (this.dateEffet === '' && this.$store.state.devis.duree === '') this.dateEcheance = '';
                let inter = dayjs(this.dateEffet).add(this.$store.state.devis.duree, 'month').format('YYYY-MM-DD');
                this.dateEcheance = dayjs(inter).add(-1, 'day').format('YYYY-MM-DD')
            },
            disabledBeforeToday(date) {
                const today = new Date();
                return date > today;
            },
        
            disabledAfterToday(date) {
                const today = dayjs(new Date()).add(-1, 'day')
                return date < today;
            },
            getPrimeSimulate() {
                if(this.brancheTocheck == 'Voyage') {
                    if(this.destination && this.dateDepart && this.dateArrivee) {
                        let item = this.listdevis[0]
                    let partenaires = []

                    for (let index = 0; index < this.countries.length; index++) {
                        if (this.countries[index].PAYS === this.destination) {
                            this.destination = this.countries[index]
                        }
                    }


                    for(let assur of this.assureurs){
                        partenaires.push(assur.societe)
                    }

                    const Voyage = {
                        destination: this.destination,
                        nbpassager: item.nbpassager,
                        dateEffet: this.dateDepart,
                        dateEcheance: this.dateArrivee,
                        dateNaissance: item.listPassager[0].dateNaissance,
                        duree: this.duree_contrat,
                        dateSouscription: dayjs(new Date()).format('YYYY-MM-DD'),
                        mode_remboursement: item.mode_remboursement_voyage,
                        dateDepart: this.dateDepart,
                        dateArrivee: this.dateArrivee,
                        assureurs: partenaires,
                        branche: "Voyage",
                        listPassager: item.listPassager,
                        garanties: configVoyage.French.Garanties,
                        plateforme:"Front",
                        autres_garanties: this.autres_garanties
                    };

                    this.dialogSimulateLoading = true
                    Api().post('simulator/add', Voyage)
                    .then(result => {
                        if (result.data.message) {
                            this.$store.dispatch('setDevis', result.data)
                            this.dialogSimulateLoading = false
                            window.location.reload()
                        } else {
                            this.dialogSimulateLoading = false
                            this.$toasted.show('Aucun résultat retourné par la simulation.', this.ToastTabError)
                        }
                    })
                    .catch(err => {
                        console.error(err)
                        this.dialogSimulateLoading = false
                        this.$toasted.show('La simulation a échoué. Veuillez réessayer.', this.ToastTabError)
                    })
                    }else {
                        this.$toasted.show('Champs obligatoires ! ', this.ToastTabError)
                    }
                } else {
                    let item = this.listdevis[0]

if(this.duree) {
    this.dateEffet =item.dateEffet;
    let inter = dayjs(this.dateEffet).add(this.duree, 'month').format('YYYY-MM-DD');
    item.dateEcheance = dayjs(inter).add(-1, 'day').format('YYYY-MM-DD')
    let vehicul = []
    let partenaires = []

    for(let assur of this.assureurs){
        partenaires.push(assur.societe)
    }

    let vehicule = {
        categorie   : item.vehicul[0].categorie,
        tonnage     : this.tonnage,
        optionUtilitaire  : null,
        volumetrie2_roues : null,
        optionPersoTrans  : item.vehicul[0].optionPersoTrans,
        carburation     : item.vehicul[0].carburation,
        marque          : null,
        carosserie      : null,
        model           : null,
        force           : item.vehicul[0].force,
        dateCircule     : dayjs(item.vehicul[0].dateCircule).format('YYYY-MM-DD') ,
        age             : item.vehicul[0].age,
        annee_mois      : item.vehicul[0].annee_mois,
        nbplace         : item.vehicul[0].nbplace,
        valeur          : item.vehicul[0].valeur,
        valeur_venale   : item.vehicul[0].valeur_venale,
        immatriculation : null,
        flotte_mono     : 'mono',
        garanties : item.vehicul[0].garanties
    }

    if(vehicule.categorie == 'categorie 5') {
        vehicule.volumetrie2_roues = item.vehicul[0].volumetrie2_roues
        vehicule.dateCircule = 'N.A'
    }

    

    vehicul.push(vehicule)



    let OneautoToSimule = {
        dateEffet: item.dateEffet,
        dateEcheance: item.dateEcheance,
        createur: this.$store.state.user._id,
        branche: "Automobile",
        duree: this.duree,
        dateSouscription: dayjs(new Date()).format('YYYY-MM-DD'),
        vehicule: vehicul,
        assureurs: partenaires,
        plateforme : 'Front',
    }

    this.dialogSimulateLoading = true
    Api().post('simulator/add', OneautoToSimule)
        .then(result => {
            if (result.data.message) {
                let data = {
                    ...result.data,
                    duree: this.duree,
                }

                this.$store.dispatch('setDevis', data)
                this.dialogSimulateLoading = false
                window.location.reload()
            } else {
                this.dialogSimulateLoading = false
                this.$toasted.show('Aucun résultat retourné par la simulation.', this.ToastTabError)
            }
        })
        .catch(err => {
            console.error(err)
            this.dialogSimulateLoading = false
            this.$toasted.show('La simulation a échoué. Veuillez réessayer.', this.ToastTabError)
        })
}else {
    this.$toasted.show('La durée est obligatoire pour simuler ! ', this.ToastTabError)
}
                }
            },
            validMarqueModel() {
                if (this.getSimuleData.vehicul[0].categorie == '2_roues') {
                    if (this.marque && this.model && this.cylindre) {
                        this.popupAutre = false
                    } else {
                        this.$toasted.show('Champs obligatoires ! ', this.ToastTabError)
                    }
                } else {
                    if (this.marque && this.model) {
                        this.popupAutre = false
                    } else {
                        this.$toasted.show('Champs obligatoires ! ', this.ToastTabError)
                    }
                }
            },

            validateImmatriculation() {
                const regex = /^[A-Za-z0-9]{2}-[A-Za-z0-9]{4}-[A-Za-z0-9]{2}$/;
                if (!regex.test(this.immatriculation)) {
                    this.immatriculation = this.immatriculation.replace(/[^A-Za-z0-9-]/g, '');
                }
            },

            onChangeSelectedMarque() {
            if (typeof this.marque == 'string') {
                if (this.marque == 'AUTRE') {
                    this.popupAutre = true;
                    this.marque = ''
                } else {
                    let selMarque = _.where(MarqueVehicule, {
                    'Marque': this.marque
                    });
                    this.listeModeles = selMarque
                    this.listeModeles[0] = "AUTRE";
                    this.selectedMarque = this.marque
                }
            } else if (typeof this.marque == 'object') {
                if (this.marque == "AUTRE") {
                    this.popupAutre = true;
                    this.marque = ''
                } else {
                    let selMarque = _.where(MarqueVehicule, {
                    'Marque': this.marque
                    });
                    this.listeModeles = selMarque;
                    this.listeModeles[0] = "AUTRE";
                    this.selectedMarque = this.marque;
                    this.marque = this.selectedMarque
                }
            }
            },

            onChangeSelectedModele: function (mark) {
            if (typeof mark == 'string') {
            if (mark == "AUTRE") {
                this.popupAutre = true;
                this.model = ''
            } else {
                let selMarque = _.where(MarqueVehicule, {
                'Type': mark
                });
                this.listeModeles = selMarque;
                this.selectedMarque = mark.Type;
            }
            } else if (typeof mark == 'object') {
            if (mark.Type == "AUTRE") {
                this.popupAutre = true;
                this.model = ''
            } else {
                let selMarque = _.where(MarqueVehicule, {
                'Type': mark.Type
                });
                this.listeModeles = selMarque;
                this.selectedMarque = mark.Type;
                this.model = this.selectedMarque;
            }
            }
            },

            onChangeSelectedMarque2roues() {
            if (typeof this.marque == 'string') {
            if (this.marque == "AUTRE") {
                this.popupAutre = true;
                this.marque = ''
            } else {
                let selMarque = _.where(Marque2roues, {
                'Marque': this.marque
                });
                this.listeModeles2roues = selMarque;
                this.listeModeles2roues[0] = "AUTRE"
                this.selectedMarque = this.marque
            }
            } else if (typeof this.marque == 'object') {
            if (this.marque == "AUTRE") {
                this.popupAutre = true;
                this.marque = ''
            } else {
                let selMarque = _.where(Marque2roues, {
                'Marque': this.marque
                });
                this.listeModeles2roues = selMarque;
                this.listeModeles2roues[0] = "AUTRE";
                this.selectedMarque = this.marque;
                this.marque = this.selectedMarque

            }
            }
            },

            onChangeSelectedModele2roues: function (mark) {
            if (typeof mark == 'string') {
            if (mark == "AUTRE") {
                this.popupAutre = true;
                this.model = ''
            } else {
                let selMarque = _.where(MarqueVehicule, {
                'Type': mark
                });
                this.listeModeles = selMarque;
                this.selectedMarque = mark.Type;
                this.e1 = 5
            }
            } else if (typeof mark == 'object') {
            if (mark.Type == "AUTRE") {
                this.popupAutre = true;
                this.model = ''
            } else {
                let selMarque = _.where(MarqueVehicule, {
                'Type': mark.Type
                });
                this.listeModeles = selMarque;
                this.selectedMarque = mark.Type;
                this.model = this.selectedMarque;
                this.e1 = 5
            }
            }
            },
            getCarForDevis (item) {
                this.carDetails = item
                if(this.getSimuleData.vehicul[0].nbplace === Number(this.carDetails.nbplace.replace(/[^0-9.-]+/g, ""))) {
                    if(this.getSimuleData.vehicul[0].valeur_venale != null){
                        if(this.carDetails.valeur_venale === this.getSimuleData.vehicul[0].valeur_venale) {
                            this.ModalListeContrat = false
                            this.infosSupOfVehicle = true
                            this.marque = this.carDetails.marque
                            this.model = this.carDetails.model
                            this.immatriculation = this.carDetails.immatriculation
                        } else {
                            this.$toasted.show("La valeur actuelle du véhicule est différent de celle de la simulation !", this.ToastTabError)
                        }
                    }else {
                        this.ModalListeContrat = false
                        this.infosSupOfVehicle = true
                        this.marque = this.carDetails.marque
                        this.model = this.carDetails.model
                        this.immatriculation = this.carDetails.immatriculation
                    }
                } else {
                    this.$toasted.show("Le nombre de place du véhicule est différent de celui de la simulation !", this.ToastTabError)
                }
            },
            //Date object formater to String
                DateFormater: function (TheDate) {
                    if (TheDate) {
                    return dayjs(TheDate).format('DD-MM-YYYY')
                    }
                },
            getUserCars() {
                Api().post("flette/listing/", { userid: store.state.user._id })
                .then(response => {
                    this.listCars = response.data.cars
                });
            },
            
            getListVehicule() {
                if(this.myCars == "nouveau") {
                    this.getSimuleCarModal = true
                    this.infosSupOfVehicle = true
                    this.immatriculation = null
                    this.marque = null
                    this.model = null
                } else if(this.myCars == "mes_vehicule") {
                    if (!store.state.isUserLoggedIn) {
                        // this.$toasted.show('Identifiez-vous pour une meilleure expérience !', this.ToastTabError)
                        // this.showLoginForm = true
                    } else {
                        
                        this.getUserCars()
                        this.ModalListeContrat = true
                        this.listCars = this.userCars
                        //this.getSimuleCarModal = true
                        this.infosSupOfVehicle = false
                        // this.immatriculation = null
                        // this.marque = null
                        // this.model = null

                        // this.ModalListeContrat = true
                        // 
                        // this.myCars = 'mes_vehicule'
                    }
                }
            },

            showDetailAuto(){
                if(this.ifDevisIsAuto == false){
                    this.ifDevisIsAuto = true
                }else{
                    this.ifDevisIsAuto = false
                }

            },

            fetchEventsList() {
                this.Mano = this.Mano - 1;
                if (this.Mano == 0) {
                    this.ExitByUser = false;
                    this.$store.dispatch('setDevis', null);
                    this.$router.push('/')
                }
            },

            isMobile: function () {
                if (screen.width <= 760) {
                    return true;
                } else {
                    return false;
                }
            },

            isTablette() {
                if (screen.width > 425 && screen.width <= 768) {
                    return true
                } else {
                    return false
                }
            },

            isDesktop: function () {
                if (screen.width > 760) {
                    return true;
                } else {
                    return false;
                }
            },

            assistanceDialogManip(devis){
                if (!store.state.isUserLoggedIn) {
                    this.$toasted.show('Identifiez-vous pour continuer !', this.ToastTabError)
                    this.showLoginForm = true
                } else {
                    this.devis_price = devis.tarif
                    this.GtmAssistanceVal.branche = devis.branche.toLowerCase()
                    this.GtmAssistanceVal.insurer_name = devis.nom
                    this.GtmAssistanceVal.step = 1
                    this.GtmAssistanceVal.event = 'receive_call_step1'

                    PushInDataLayer(this.GtmAssistanceVal)

                    this.objetRappel = 'Sim : ' + devis.numero;
                    this.name = store.state.user.prenom.toUpperCase() + '-' + store.state.user.nom.toUpperCase();
                    this.tel = store.state.user.telephone_port;
                    this.assistanceDialog = true
                }
            },

            AddAssistance()
            {
                if (this.horaire && this.canal && this.name && this.tel && this.objetRappel && this.remarques) {
                    const assist = {
                        horaire: this.horaire,
                        canal: this.canal,
                        name: this.name,
                        tel: this.tel,
                        objetRappel: this.objetRappel,
                        remarques: this.remarques,
                        userid: store.state.user._id
                    };

                    let Gtm2 = {
                        branche : this.GtmAssistanceVal.branche,
                        schedule : this.horaire,
                        insurer_name : this.GtmAssistanceVal.insurer_name,
                        step : 2,
                        price : this.devis_price,
                        channel :this.canal,
                        event : 'receive_call_step2'
                    }

                    Api().post('assistances/create', assist)
                        .then(resp => {
                            PushInDataLayer(Gtm2)
                            if (resp.data.info == 'ok')
                            {
                                this.$toasted.show(resp.data.msg, this.ToastTabSucess);
                                this.assistanceDialog = false;
                                this.horaire = '';
                                this.canal = '';
                                this.name = '';
                                this.tel = '';
                                this.objetRappel = '';
                                this.remarques = ''
                            } else if (resp.data.info == 'nok')
                            {
                                this.$toasted.show(resp.data.msg, this.ToastTabError)
                            }
                        })

                } else {
                    this.$toasted.show("Tous les champs sont obligatoires !", this.ToastTabError)
                }

            },

            getPartner: function (assur) {
                let partenaire = this._.find(this.$store.state.devis.result.partenaire, function (o) {
                    return o._id === assur
                });
                return partenaire
            },

            btn1_clicked: function (item)
            {
                let Gtmval = {
                    branche:item.branche.toLowerCase(),
                    insurer_name:item.nom,
                    price:item.tarif,
                    event:'view_price'
                }

                PushInDataLayer(Gtmval)

                this.HideDive = item.id;
                this.HideButton = item.id + 'hidden'
            },

            createDevis: function () {
                if(this.brancheTocheck != 'Voyage') {
                    if(this.getSimuleData.vehicul[0].categorie == 'categorie 5') {
                    if(this.marque == null || this.model == null || this.dateEffet == null) {
                    this.$toasted.show("Tous les champs sont obligatoires !", this.ToastTabError)
                    return
                } else {
                    this.getSimuleData.vehicul[0].marque = this.marque
                    this.getSimuleData.vehicul[0].model = this.model
                    this.getSimuleData.vehicul[0].immatriculation = 'N.A'

                    const OneautoToSave = {
                        userid: store.state.user._id,
                        dateEffet: this.dateEffet,
                        createur : store.state.user._id,
                        proprietaire : {
                            nom: store.state.user.nom,
                            prenom: store.state.user.prenom,
                            telephone: store.state.user.telephone_port,
                            email: store.state.user.email
                        },
                        dateEcheance: this.dateEcheance,
                        dateSouscription: dayjs(new Date()).format('YYYY-MM-DD'),
                        plateforme: 'front',
                        branche: this.getSimuleData.branche,
                        duree: store.state.devis.duree,
                        vehicule: this.getSimuleData.vehicul,
                        assureurs: [this.getSimuleData.nom],
                        
                    }

                    this.getSimuleCarModal = false;

                    
                    setTimeout(() => (
                        this.dialogLoading = true,
                        Api().post('devis/add', OneautoToSave)
                        .then(response => {
                            Api().get('devis/' + response.data.result.devis[0]._id)
                            .then(response => {
                                this.$store.dispatch('setDevisPayement', response.data);
                                this.$router.push('/payement')
                            })
                        })
                    ), 1000)
                }
                } else {
                    if(this.marque == null || this.model == null || this.immatriculation == null || this.dateEffet == null) {
                    this.$toasted.show("Tous les champs sont obligatoires !", this.ToastTabError)
                    return
                } else {
                    this.getSimuleData.vehicul[0].marque = this.marque
                    this.getSimuleData.vehicul[0].model = this.model
                    this.getSimuleData.vehicul[0].immatriculation = this.immatriculation

                    const OneautoToSave = {
                        userid: store.state.user._id,
                        dateEffet: this.dateEffet,
                        createur : store.state.user._id,
                        proprietaire : {
                            nom: store.state.user.nom,
                            prenom: store.state.user.prenom,
                            telephone: store.state.user.telephone_port,
                            email: store.state.user.email
                        },
                        dateEcheance: this.dateEcheance,
                        dateSouscription: dayjs(new Date()).format('YYYY-MM-DD'),
                        plateforme: 'front',
                        branche: this.getSimuleData.branche,
                        duree: store.state.devis.duree,
                        vehicule: this.getSimuleData.vehicul,
                        assureurs: [this.getSimuleData.nom],
                        
                    }

                    this.getSimuleCarModal = false;

                    
                    setTimeout(() => (
                        this.dialogLoading = true,
                        Api().post('devis/add', OneautoToSave)
                        .then(response => {
                            Api().get('devis/' + response.data.result.devis[0]._id)
                            .then(response => {
                                this.$store.dispatch('setDevisPayement', response.data);
                                this.$router.push('/payement')
                            })
                        })
                    ), 1000)
                }
                }
                }else { 
                    const Voyage = {
                        user: store.state.user._id,
                        createur : store.state.user._id,
                        proprietaire : {
                            nom: store.state.user.nom,
                            prenom: store.state.user.prenom,
                            telephone: store.state.user.telephone_port,
                            email: store.state.user.email
                        },
                        destination: this.getSimuleData.destination,
                        nbpassager: this.getSimuleData.nbpassager,
                        dateEffet: this.getSimuleData.dateEffet,
                        dateNaissance: this.getSimuleData.listPassager[0].dateNaissance,
                        dateEcheance: this.getSimuleData.dateEcheance,
                        duree: this.getSimuleData.dureeVoyage,
                        dateSouscription: dayjs(new Date()).format('YYYY-MM-DD'),
                        mode_remboursement: this.getSimuleData.mode_remboursement_voyage,
                        dateDepart: this.getSimuleData.dateEffet,
                        dateArrivee: this.getSimuleData.dateEcheance,
                        assureurs: [this.getSimuleData.nom],
                        branche: this.getSimuleData.branche,
                        listPassager: this.getSimuleData.listPassager,
                        garanties: this.getSimuleData.garanties,
                        pays_domicile : 'Sénégal',
                        plateforme:"Front",
                        autres_garanties: this.getSimuleData.autres_garanties
                    };

                        this.dialogLoading = true,
                        Api().post('devis/add', Voyage)
                        .then(response => {
                            Api().get('devis/' + response.data.result.devis[0]._id)
                            .then(response => {
                                this.$store.dispatch('setDevisPayement', response.data);
                                this.$router.push('/payement')
                            })
                        })
                

                }
              


             
            },


            btn2_clicked: function (devis) {
                if (!store.state.isUserLoggedIn) {
                    this.$toasted.show('Identifiez-vous pour continuer !', this.ToastTabError)
                    this.showLoginForm = true
                } else {
                    if(this.brancheTocheck == 'Automobile') {
                        store.state.isUserLoggedIn = true
                        this.getSimuleData = devis;
                        //console.log(":::::::: categorie ::::::::::::::::::", this.getSimuleData.vehicul[0].categorie)
                        this.getSimuleCarModal = true;
                    } else if(this.brancheTocheck == 'Voyage') {
                        store.state.isUserLoggedIn = true
                        this.getSimuleData = devis;
                        this.createDevis()
                    }
                }
            },

            btn3_clicked: function () {
                this.HideDive2 = true;
                this.HideButton2 = false;
            },

            getImgUrl(pic) {
                if (pic) {
                    return pic
                } else {
                    return require('../../assets/img/assuraf_sm.png')
                }
            },

            SendDevisByMail: function (devis)
            {
                let Gtmval = {
                    branche:devis.branche.toLowerCase(),
                    insurer_name:devis.nom,
                    price:devis.tarif,
                    event:'quote_by_mail'
                }

               PushInDataLayer(Gtmval)

                Api().get('devis/mydevisbyemail/' + devis.id)
                .then(response => {
                    this.notif = response.data.info
                })
            },

            Download_devis: function (devis){
                //console.log(":::::::: devi ::::::::::::", devis)

                let Gtmval = {
                    branche:devis.branche.toLowerCase(),
                    insurer_name:devis.nom,
                    price:devis.tarif,
                    event:'download_quote'
                }

               PushInDataLayer(Gtmval)

                Api().get('devis/download/' + devis.id)
                    .then(response => {
                        let url = response.data.lien;
                        //console.log(":::::::: url devis ::::::::::::", url)
                        this.dialogLoading = true;
                        let WinOpener = null
                            this.dialogLoading = false, 
                            WinOpener = window.open(),
                            WinOpener.location = url
                        })
            },

            DataLayerPusherCheckValue(tab,val){
                let checker = 0
                for(let t of tab)
                {
                    if(t.item_id==val)
                    {
                        checker = 1
                    }
                }
                return checker
            },

        },
        beforeDestroy() {
            clearInterval(this.timer);
            if (this.ExitByUser == true) {
                this.$store.dispatch('setDevis', null)
            }

        },
        watch: {
            categorie(v) {
                switch (v) {
                    case '2_roues': this.MarqueAuto = MarqueImage.moto; break
                    default:  this.MarqueAuto = MarqueImage.auto;  break
                }            
            },
            model(val) {
                if (typeof val == 'object') {
                    this.model = val.Type
                } else if (typeof val == 'string') {
                    this.model = val
                }
            },
            notif: function () {
                if (this.notif == 'ok') {
                    this.$toasted.show('Votre devis vous a été envoyé par mail !', this.ToastTabSucess);
                    this.notif = null
                } else if (this.notif == 'nok') {
                    this.$toasted.show("L'envoi du devis par mail a échoué !", this.ToastTabError);
                    this.notif = null
                }
            }
        },
        mounted() {
            window.scrollTo(0, 0);
            let dernierDevis = [];
            if (this.$store.state.devis && this.$store.state.user) {
                this.Mano = 20;
                dernierDevis = this.$store.state.devis.result.devis;
                this.getSimuleData = dernierDevis
                this.assureurs = this.$store.state.devis.result.partenaire;
                let branche = this.$store.state.devis.result.branche;
                this.brancheTocheck = this.$store.state.devis.result.branche.branche;
                let items = []
                localStorage.setItem('item_list_name', 'Devis créés')
                if (branche.branche == 'Automobile') { // Dans le cas de voyage on cree un tableau avec des libelles pour Auto
                    for (let ass of this.assureurs) {
                        for (let dev of dernierDevis)
                        {
                            if (ass._id == dev.partenaireid)
                            {
                                items.push({
                                    'item_name': 'Assurance automobile',
                                    'item_id': dev.numeroDevis,
                                    'price': Math.round(dev.prime_ttc/655.957),
                                    'item_brand':ass.societe,
                                    'item_category': branche.branche,
                                    'item_list_name': 'Devis créés',
                                    'index': items.length,
                                    'quantity':1,
                                })
                                this.listdevis.push({
                                    id: dev._id,
                                    numero: dev.numeroDevis,
                                    image: ass.logo,
                                    nom: ass.societe,
                                    branche:'Automobile',
                                    tarif: dev.prime_ttc,
                                    prime_nette: dev.prime_nette,
                                    dateEffet: dev.dateEffet,
                                    dateEcheance: dev.dateEcheance,
                                    vehicul: dev.vehicules,
                                    garanties: dev.garanties,
                                    matchingArray: dev.ArrayStringGaranties
                                    // Autres completer a la suite

                                })
                            }
                        }
                    }
                } else if (branche.branche == 'Voyage') { 
                    this.getListePays() // Dans le cas de voyage on cree un tableau avec des libelles pour voyage
                    for (let ass of this.assureurs) {
                        for (let dev of dernierDevis) {
                            if (ass._id == dev.partenaireid)
                            {
                                items.push({
                                    'item_name': 'Assurance voyage',
                                    'item_id': dev.numeroDevis,
                                    'price':Math.round(dev.prime_ttc/655.957),
                                    'item_brand':ass.societe,
                                    'item_category': branche.branche,
                                    'item_list_name': 'Devis créés',
                                    'index': items.length,
                                    'quantity':1,
                                })

                                this.listdevis.push({
                                    id: dev._id,
                                    numero: dev.numeroDevis,
                                    image: ass.logo,
                                    nom: ass.societe,
                                    branche:'Voyage',
                                    tarif: dev.prime_ttc,
                                    prime_nette: dev.prime_nette,
                                    dateEffet: dev.dateEffet,
                                    dateEcheance: dev.dateEcheance,
                                    dateNaissance : dev.dateNaissance,
                                    nbpassager: dev.nbpassager,
                                    listPassager : dev.listPassager,
                                    pays_domicile: dev.pays_domicile,
                                    destination: dev.destination,
                                    garanties: dev.garanties,
                                    dureeVoyage : dev.dureeVoyage,
                                    mode_remboursement_voyage : dev.mode_remboursement_voyage,
                                    optionAss: ['Assistance', 'Remplacement', 'Orientation sinistre']
                                    // Autres completer a la suite

                                })
                            }
                        }
                    }
                }

                if(document.readyState=='complete')
                {
                    localStorage.setItem('EcommercePushed',true)
                        PushInDataLayer({
                            'event': 'view_item_list',
                            'ecommerce':{
                            items
                        }
                    })
                }
            } else {
                this.$router.push('/')
            }
        }
    }
</script>

<style scoped>
    @import "../../assets/css/liste_devis.css";
    @import "../../assets/css/liste_devis_button.css";
    @import "../../assets/css/devis_css.css";
    @import "../../assets/css/button.css";
    /* .container {
          padding: 0px !important;
      } */
    .row-container {
        background: white;
    }

    .List-garanties-option li {
        list-style: none;
        border-bottom: 1px solid lightgrey;
    }

    .List-cout li {
        list-style: none;
    }

    .list-boutons li {
        list-style: none;
    }

    .logo-assureur {
        border: 1px solid lightgrey;
    }

    .right--texting {
        text-align: right;
    }

    .right--texting ul li .col-lg-6:hover {
        background: #ffa409;
        color: white;
        text-decoration: none;
    }

    .greyLabel {
        color: grey
    }

    .selectatDesktop {
        background: url(https://) no-repeat right;
        -webkit-appearance: none;
        background-position-x: 90%;
        border-bottom: 1px solid gray;
    }

    .georgia {
        font-family: Georgia !important;
    }

    .border-radius {
        border-radius: 20px !important
    }

    .focusablee :hover {
        background: #DCDCDC;
    }

    .policeLato{
        font-family: Lato, "Helvetica Neue", Arial, sans-serif
    }




    .pricing-box {
    background: white;
    box-shadow: 0 3px 12px rgba(6, 11, 47, 0.06);
    margin-bottom: 30px;
    position: relative;
    overflow: hidden;
    .pricing-icon-bg {
        background: rgba(#ffa409, 0.12);
        color: ffa409;
        display: block;
        height: 80px;
        width: 80px;
        line-height: 100px;
        margin: 0 auto;
        border-radius: 20% 20% 4% 20% / 20% 20% 4% 20%;
        box-shadow: 0 0 0 7px rgba(#ffa409, 0.03);
        transition: all 0.5s;
    }
    .pricing-item {
        li {
            padding: 10px 0;
        }
    }
    .pr-btn {
        position: relative;
        z-index: 1;
        color: #ffa409;
        border: 1px solid #ffa409;
        
    }
    .pr-btn:hover {
        background-color: #ffa409;
        color: #fff;
    }
    &:hover, &.active {
        .pricing-icon-bg {
            background-color: #ffa409;
            box-shadow: 0 0 0 7px rgba(ffa409, 0.06);
            color: white;
            border-radius: 4% 20% 20% 20% / 4% 20% 20% 20%;
        }
    }
}

.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}
</style>
